/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateAssetCustomFieldValueResponseDto
 */
export interface CreateAssetCustomFieldValueResponseDto {
    /**
     * 
     * @type {string}
     * @memberof CreateAssetCustomFieldValueResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAssetCustomFieldValueResponseDto
     */
    assetCustomFieldId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAssetCustomFieldValueResponseDto
     */
    assetId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAssetCustomFieldValueResponseDto
     */
    value: string | null;
}

/**
 * Check if a given object implements the CreateAssetCustomFieldValueResponseDto interface.
 */
export function instanceOfCreateAssetCustomFieldValueResponseDto(value: object): value is CreateAssetCustomFieldValueResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('assetCustomFieldId' in value) || value['assetCustomFieldId'] === undefined) return false;
    if (!('assetId' in value) || value['assetId'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function CreateAssetCustomFieldValueResponseDtoFromJSON(json: any): CreateAssetCustomFieldValueResponseDto {
    return CreateAssetCustomFieldValueResponseDtoFromJSONTyped(json, false);
}

export function CreateAssetCustomFieldValueResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateAssetCustomFieldValueResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'assetCustomFieldId': json['assetCustomFieldId'],
        'assetId': json['assetId'],
        'value': json['value'],
    };
}

export function CreateAssetCustomFieldValueResponseDtoToJSON(json: any): CreateAssetCustomFieldValueResponseDto {
    return CreateAssetCustomFieldValueResponseDtoToJSONTyped(json, false);
}

export function CreateAssetCustomFieldValueResponseDtoToJSONTyped(value?: CreateAssetCustomFieldValueResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'assetCustomFieldId': value['assetCustomFieldId'],
        'assetId': value['assetId'],
        'value': value['value'],
    };
}

